<template>
    <div class="login-content">
        <div class="containessr">
            <div class="row">
                <div class="col-lg-6">
                    <div class="image-login">
                        <!-- <img src="./assets/images/login.jpg" alt=""> -->
                    </div>
                </div>
                <div class="col-lg-6 align-content-center">
                    <div v-if="!user">
                        <sign-in @userLogin="set_user($event)" @signUp="signup = $event" v-show="!signup"></sign-in>
                        <sign-up :withAuth="true" @sign-in="signup = $event" v-show="signup"></sign-up>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SignIn from './SignIn.vue';
    import SignUp from './SignUp.vue';
    export default {
        name: 'AuthPage',
        props: [],
        components: { SignIn, SignUp },
        data(){
            return {
                signup: false,
            }
        }
    }
</script>